export default {
    default: [
        {
            hoverControl: false,
            label: 'Header Code',
            membership: ['PLAN_1', 'PLAN_2', 'PLAN_3'],
            modules: [
                {
                    path: 'advanced/headerInject',
                    content: {
                        template: 'CodeEditor',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Footer Code',
            membership: ['PLAN_1', 'PLAN_2', 'PLAN_3'],
            modules: [
                {
                    path: 'advanced/footerInject',
                    content: {
                        template: 'CodeEditor',
                    },
                },
            ],
        },
    ],
};
